import Card from "@rio-cloud/rio-uikit/Card";
import { useT } from "@hooks";

export interface HorizontalBarItem {
  label: string;
  value: number;
}

interface HorizontalBarListProps {
  title: string;
  items: HorizontalBarItem[];
  color: string;
  labelWidth?: number;
}

const DEFAULT_LABEL_WIDTH = 110;
const BAR_HEIGHT = 34;
const BAR_RADIUS = 4;

const formatCurrency = (value: number) =>
  `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function HorizontalBarList({
  title,
  items,
  color,
  labelWidth = DEFAULT_LABEL_WIDTH,
}: Readonly<HorizontalBarListProps>) {
  const t = useT();
  const maxValue = items.reduce((max, item) => Math.max(max, item.value), 0);

  return (
    <Card className="padding-y-25 padding-x-15 padding-x-25-sm display-flex flex-column height-100pct">
      <div className="padding-bottom-20">
        <span className="text-size-16 text-bold">{title}</span>
      </div>
      <div className="flex-1-1 display-flex flex-column justify-content-center gap-20 padding-15 rounded border border-width-1 border-color-light">
        {items.length === 0 ? (
          <span className="text-center text-color-gray text-size-14">{t("common.label.noData")}</span>
        ) : (
          items.map((item) => {
            const percentage = maxValue > 0 ? (item.value / maxValue) * 100 : 0;
            return (
              <div key={item.label} className="display-flex align-items-center gap-10">
                <span
                  className="text-size-14 text-color-darker flex-0"
                  style={{ width: labelWidth, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                  title={item.label}
                >
                  {item.label}
                </span>
                <div className="flex-1-1 display-flex align-items-center gap-10 min-width-0">
                  <div
                    data-testid="barra-horizontal"
                    style={{
                      width: `${percentage}%`,
                      height: BAR_HEIGHT,
                      borderRadius: BAR_RADIUS,
                      backgroundColor: color,
                      flexShrink: 1,
                      minWidth: 0,
                    }}
                  />
                  <span className="text-size-14 text-color-darker white-space-nowrap">
                    {formatCurrency(item.value)}
                  </span>
                </div>
              </div>
            );
          })
        )}
      </div>
    </Card>
  );
}
